<template>
  <div class="Login">
    <div class="f-1">
      <div class="content-sm">
        <div class="LoginButtons">
            <span id="LinkGoToLogin" class="RouteLink-Active">Giriş Yap</span>
            <span id="LinkGoToRegister" @click="routeToRegister" class="RouteLink-Passive">Üye Ol</span>
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <ValidationProvider name="E-Posta veya TCKN" rules="required|isTcknOrEmail" v-slot="{ errors, touched }">
              <div class="mb-60" :class="{'with-error': errors[0]&&touched}">
                <Input
                  id="InputEmailTC"
                  placeholder="E-Posta veya T.C. Kimlik Numaranız"
                  v-model="email"
                  @focus="inputFocus"
                  @blur="inputBlur"
                />
                <span v-if="touched">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider name="Şifre" rules="required|noStartWithX:0|noWhiteSpaces|min:6|max:20|noRepeatedChars|containsConsecutiveChars" v-slot="{ errors , touched }">
              <div class="mb-40" :class="{'with-error': errors[0]&&touched}">
                <PasswordInput id="InputPassword" placeholder="Şifreniz" v-model="password" @focus="inputFocus" @blur="inputBlur"/>
                <span v-if="touched">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <div class="d-flex a-center mb-20">
              <Switcher id="SwitchRemember" v-model="remember">Beni Hatırla</Switcher>
              <router-link
                id="LinkGoToForgotPassword"
                to="/forgot-password"
                class="ml-auto"
              >Şifremi Unuttum</router-link>
            </div>
              <Recaptcha v-if="reCaptchaLimitExceeded" ref="recaptcha" @loaded="loadedRecaptcha" @verify="submit"></Recaptcha>
            <button
              id="BtnContinue"
              type="submit"
              @click.prevent="onSubmit"
              :disabled="disabled||invalid"
            >Giriş Yap</button>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <div class="separator" v-show="showQr">
      <span>veya</span>
    </div>
    <div class="f-1" v-if="showQr">
      <QRCode />
    </div>
  </div>
</template>
<script>
import {mapActions,mapGetters} from "vuex";
import GeneralUtil from "../lib/util/generalUtil"
import {QrPaymentStatus,QrStatus} from "../lib/vuex/modules/common/common";
import router from "../lib/router"
import store from '../lib/vuex/store'

export default {
  name: "Login",
  components: {
    Switcher: () => import("../lib/components/Switcher"),
    QRCode: () => import("../lib/components/QRCode"),
    Input: () => import("../lib/components/Input"),
    PasswordInput: () => import("../lib/components/PasswordInput"),
    Recaptcha: () => import("../lib/components/Recaptcha"),
    InfoModal: () => import("../lib/components/InfoModal/InfoModal"),
    ApproveModal: () => import("../lib/components/ApproveModal/ApproveModal")
  },
  data: function () {
    let rememberCookie = this.$cookie.get('remember');
    let nameCookie = this.$cookie.get('username');
    return{
      remember: false,
      email: rememberCookie ? this.checkTCKNMask(nameCookie) : "",
      password: "",
      showTokenInput:false,
      grecaptcha: "",
      getTrInfo:null,
      qrPooling : null,
      qrTimeout : null,
      showQrCode:false,
      qrTryCount:0,
      showQrFlag:false,
      modalTxt: "test1",

    }
  },
  async mounted(){
        //console.log("Login Mounted-this.token:",this.token);
        //console.log("purchaseInfo-purchaseInfo.token",this.purchaseInfo.token);
        if(new Date(this.purchaseInfo.expires) - new Date()<0){
          //console.log("Login.vue-Purchase is Expired")
          window.location = process.env.VUE_APP_CUZDAN_URL;
        }else if(this.token==="" || this.token===undefined) {
          //console.log("dExpires-dNewDate:",new Date(this.purchaseInfo.expires)-new Date());
          let response = await this.getTransactionInfo(this.purchaseInfo);
          if(response.emvQrText!==null && response.emvQrText!==undefined){
                //console.log("response.emvQrText:",response.emvQrText)
                //console.log("Init QR***")
                this.showQrFlag=true;
                this.qrInit();
                this.checkQrTimeout();
          }
          //console.log("getTransactionInfo-response:",response);
        }
        this.setRegisterFlow(false);
        this.setLoading(false)
    },
  created(){
      //console.log("Login Created");
    },
    beforeDestroy () {
        clearInterval(this.qrPooling);
        clearTimeout(this.qrTimeout);
  },
  computed: {
        ...mapGetters({
            authToken: "getAuthToken",
            reCaptchaLimitExceeded: 'reCaptchaLimitExceeded',
            reCaptchaResponse: 'reCaptchaResponse',
            qrtext:'getEmvQrText',
            initInfo:'getInitInfo',
            purchaseInfo:'getPurchaseInfo',
            capchaEnable:'getCapchaEnable',
            qrPaymentStatus:'qrPaymentStatus',
            token:'getPurchaseToken',
            qrStatus:'getQrStatus',
            paybyLinkFlow:'getPaybyLinkFlow',
            quickPayFlow:'getQuickPayFlow',

    }),
    disabled() {
      return !this.email || !this.password || !(this.reCaptchaLimitExceeded ? this.reCaptchaResponse : true);
    },
    showQr(){
      return (!this.paybyLinkFlow && !this.quickPayFlow )
        && this.qrtext && (this.qrStatus === QrStatus.CREATED || this.qrStatus === QrStatus.NA);
    }
  },
  methods: {
    ...mapActions({
        login: 'login',
        setAuthToken: 'setAuthToken',
        setLoading:'setLoading',
        getTransactionInfo:'getTransactionInfo',
        verifyCaptchaOnSubmit: 'verifyCaptchaOnSubmit',
        setRegisterFlow: 'setRegisterFlow',
        queryQrStatus:'queryQrStatus',
        setQrPaymentStatus:'setQrPaymentStatus',
        setQrLoading:'setQrLoading',
        setInputFocus:'setInputFocus',
        setQrStatus:'setQrStatus',
        setRecaptchaFalse:'setRecaptchaFalse',
    }),
    qrInit: function(){
      //console.log("qrInit-this.qrPaymentStatus:"+this.qrPaymentStatus);
      if(this.qrPaymentStatus === QrPaymentStatus.TIMEOUT
        ||this.qrPaymentStatus === QrPaymentStatus.FAIL
        ||this.qrPaymentStatus === QrPaymentStatus.CANCEL){
        this.showQrCode=false;
        clearInterval(this.qrPooling);
        clearInterval(this.qrTimeout);
      }else{
        this.qrPooling = setInterval(async() => {
          ////console.log("qrPooling-this.qrPaymentStatus:"+this.qrPaymentStatus);
          let qrStatusFromAPI = await this.queryQrStatus({token:this.token}); //Get QR Code For Payment
          ////console.log("***qrStatusFromAPI :",qrStatusFromAPI)
          if(!this.showQrFlag && qrStatusFromAPI==="C"){
            if(qrStatusFromAPI===QrStatus.CREATED)
            this.setQrStatus(QrStatus.TIMEOUT);
          }else {
            this.setQrStatus(qrStatusFromAPI);
          }
          ////console.log("Pooling Started!");
          ////console.log("QrPooling-qrStatus:" + this.qrStatus);
          if (this.qrStatus === QrStatus.READ && this.qrPaymentStatus!==QrPaymentStatus.FAIL) {
              //console.log(">QrPaymentStatus:"+this.qrPaymentStatus);
              clearTimeout(this.qrTimeout);
              //console.log("qrStatus Read - show loading, keep pooling, this.qrTimeout:Clear");
              this.setQrLoading(true);
              //this.qrLoadingDesc("BKM Express mobil uygulaması üzerinden ödeme işleminiz devam ediyor. İşlem tamamlanana kadar lütfen bu ekranı kapatmayınız.");
            if(this.qrPaymentStatus === QrPaymentStatus.CANCEL){
              //console.log("Cancel QrPayment");
              this.showQrCode=false;
              clearInterval(this.qrPooling);
            }
            this.setQrPaymentStatus(QrPaymentStatus.WAITING);
          } else if (this.qrStatus === QrStatus.FAILED) {
            //console.log("**FAIL CASE");
            this.setQrLoading(true);
            //this.qrLoadingDesc("Islem Basarısız");
            this.setQrPaymentStatus(QrPaymentStatus.FAIL);
            clearInterval(this.qrPooling);
            this.showQrCode=false;
          } else if (this.qrStatus === QrStatus.SUCCESS) {
            this.setQrPaymentStatus(QrPaymentStatus.SUCCESS);
            this.setQrLoading(false);
            //console.log("qrStatus Success - redirect to SuccessApp");
            this.showQrCode=false;
            router.push({path: '/payment/success'})
          }
          if (!this.showQrCode) {
            if(this.qrtext!==null&&this.qrtext.length > 0) {
              //console.log("qr is set to this.qrtext:" + this.qrtext);
              this.showQrCode = true;
            }else {
              this.qrTryCount++;
              //console.log("QrTry FAILED: " + this.qrTryCount);
              if(this.qrTryCount>=5){
                clearInterval(this.qrPooling);

              }
            }
          }
        }, 1000);
      }
    },
    checkQrTimeout: function(){
      this.qrTimeout = setTimeout(()=> {
        if(this.qrStatus === QrStatus.CREATED || this.qrStatus === QrStatus.NA) {
          clearInterval(this.qrPooling);
          //console.log("**checkQrTimeout TIMEOUT**");
          clearTimeout(this.qrTimeout);
          this.setQrPaymentStatus(QrPaymentStatus.TIMEOUT);
          this.showQrFlag=false;
          this.setQrStatus(QrStatus.TIMEOUT)
        }
      }, 120*1000)
    },
    inputFocus(){
      this.setInputFocus(true)
    },
    routeToRegister(){
      router.push('/register');
    },
    inputBlur(){
      this.setInputFocus(false)
    },
    onSubmit() {
      let recaptchaIsValid = this.reCaptchaLimitExceeded ? this.reCaptchaResponse : true;
      if (recaptchaIsValid) {
        this.setRecaptchaFalse();
        if (this.grecaptcha) {
          this.grecaptcha.reset();
        }
        this.login({name:this.email,password:this.password,token:this.initInfo.token,remember:this.remember,clearCaptcha:this.reCaptchaLimitExceeded});
      }
    },
    checkTCKNMask: function (name) {
      let newName = name;
      if (GeneralUtil.isTcknValid(name)) {
        newName = name.substring(0, 3) + "******" + name.substring(9, 11);
      }
      return newName;
    },
    loadedRecaptcha: function (grecaptcha) {
      this.grecaptcha = grecaptcha;
    },
    submit: function (response) {
      //console.log("verifyCaptchaOnSubmit-response:",response)
      this.verifyCaptchaOnSubmit({response:response,username:this.email});
    },
  },
};
</script>